function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.71875 0.5625L9.1875 7.03125L15.6094 0.5625C16.1719 0 17.1562 0 17.7188 0.5625C18.3281 1.17188 18.3281 2.10938 17.7188 2.71875L11.2969 9.14062L17.7188 15.5625C18.3281 16.1719 18.3281 17.1094 17.7188 17.7188C17.1562 18.2812 16.1719 18.2812 15.6094 17.7188L9.1875 11.25L2.71875 17.7188C2.15625 18.2812 1.17188 18.2812 0.609375 17.7188C0 17.1094 0 16.1719 0.609375 15.5625L7.03125 9.14062L0.609375 2.71875C0 2.10938 0 1.17188 0.609375 0.5625C1.17188 0 2.15625 0 2.71875 0.5625Z",
  fill: "black"
});

function SvgCampaignSetupClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignSetupClose);
export default __webpack_public_path__ + "static/media/campaign-setup-close.23649b84.svg";
export { ForwardRef as ReactComponent };